import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { Plantilla, PlantillasResponse } from '../../models/plantillas.model';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environments';

@Injectable({providedIn: 'root'})
export class AdministradorDePlantillasService {
    plantillas:BehaviorSubject<PlantillasResponse>= new BehaviorSubject<PlantillasResponse>(null)
    
        get plantillas$(){
            return this.plantillas.asObservable()
        }

    constructor(private apiService:ApiService, private http: HttpClient,) { }
    
    postNuevaPlantilla(body:any){
        const url='/plantillas'
                return new Promise((resolve, reject)=>{
                    this.apiService.PostMethod(url, body, {}, 'Error al guardar plantilla.')
                        .subscribe((response) => {
                            resolve(response)            
                        }, error => {
                            reject(true)
                        })
                })
    }

    getPlantillas(seccion_uuid:number, inicio:number, max:number){
        const params= {seccion: seccion_uuid, inicio: inicio, max: max}
        const url=`/plantillas` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, params, 'Error al obtener las plantillas.')
                .subscribe((response: PlantillasResponse) => {
                    this.plantillas.next(response)
                    resolve(response)                    
                }, error => {
                    reject(true)
                })
        })
    }

    actualizaPlantilla(body:any){
        const url=`/plantillas` 
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, body, 'Error al actualizar plantilla.')
                .subscribe((response: any) => {
                    resolve(response)                    
                }, error => {
                    reject(true)
                })
        })
    }

    eliminarPlantilla(plantillaId:number){
        const url=`/plantillas/${plantillaId}` 
          return new Promise((resolve, reject)=>{
            this.apiService.DeleteMethod(url, {}, 'Error al eliminar plantilla.')
                .subscribe((response: any) => {
                    resolve(response)                    
                }, error => {
                    reject(true)
                })
        })
    }

    descargarPlantilla(plantillaId:number):Promise<Blob>{
        const url=`${environment.API_SERVER_URL}/api/plantillas/obtener/${plantillaId}` 
          return new Promise((resolve, reject)=>{
            this.http.get(url, { responseType: 'blob' })
                .subscribe((responseBlob) => {
                    resolve(responseBlob);
                },error => {
                    reject(error);
                }
            );
        })
    }


}